export const processStages = [
  {
    stage: 'Discover',
    copy: 'Identify the workflow, constraints, and opportunity worth testing.',
    output: 'Pilot-fit recommendation.',
  },
  {
    stage: 'Design',
    copy: 'Define the assistant’s information, responsibilities, permissions, and success criteria.',
    output: 'Approved scope.',
  },
  {
    stage: 'Deploy',
    copy: 'Configure, test, and introduce the assistant into a controlled workflow.',
    output: 'Working pilot.',
  },
  {
    stage: 'Measure',
    copy: 'Review outputs, exceptions, costs, and team feedback against the agreed baseline.',
    output: 'Findings and recommendation.',
  },
  {
    stage: 'Expand',
    copy: 'Continue, revise, or pursue the next implementation where the evidence supports it.',
    output: 'Optional improvement roadmap.',
  },
];
